import {GetAllEnumsResponse} from '../../../types/api/api';

export type CatalogueFeatureTreeNode = {
  value: string;
  children: CatalogueFeatureTreeNode[];
};

export const buildFeatureTreesFromCatalogueKeys = (
  allKeys: GetAllEnumsResponse[number]['keys']
): CatalogueFeatureTreeNode[] => {
  const buildNode = (constKey: string): CatalogueFeatureTreeNode => ({
    value: constKey,
    children: allKeys
      .filter((key) => key.parent === constKey)
      .map((key) => buildNode(key.const_key)),
  });

  return allKeys.filter((key) => key.parent === null).map((key) => buildNode(key.const_key));
};
